export default __webpack_public_path__ + "static/media/logo-us-iherb.71502b7b.svg";